<div class="building-scan-list">
  @if (uploading()) {
    <div class="upload-progress">
      <wr-progress-bar [value]="progress()"></wr-progress-bar>
    </div>
  }
  <div class="scan-list">
    @for (pending of pendingScans(); track pending.id) {
      <wr-building-scan-pending-card [scan]="pending"
                                     [canDelete]="editMode()"
                                     (deleteImport)="deleteScanImport($event)"></wr-building-scan-pending-card>
    }

    @for (scan of filteredScans(); track scan.id) {
      <wr-building-scan-card [scan]="scan"
                             (updated)="onScanUpdated($event)"
                             [canDelete]="editMode()"
                             [canEdit]="editMode()"
                             (deleteScan)="deleteBuildingScan($event)"
                             (editScan)="editScan($event)"
      ></wr-building-scan-card>
    }
  </div>

  @if (empty()) {
    <div class="empty-text">
      <nb-icon icon="slash-outline" pack="eva"></nb-icon>
      <span>Keine Scans vorhanden</span>
    </div>
  }

  <div class="upload-section">
    @if(!uploading() && editMode()) {
      <button nbButton status="primary" (click)="fileUpload.click()" class="upload-button">
        <nb-icon icon="cloud-upload-outline" pack="eva"></nb-icon>
        <div>
          <span class="button-text">Panorama-Scan hochladen</span>
          <span class="file-hint">.e57-Datei</span>
        </div>
      </button>
      <input #fileUpload type="file" accept=".e57" (change)="onFileChange($event)"/>

      <button nbButton status="primary" class="upload-button" (click)="linkPointCloud()">
        <nb-icon icon="link-2-outline" pack="eva"></nb-icon>
        <div>
          <span class="button-text">Punktwolke verknüpfen</span>
          <span class="file-hint">Benaco-UUID</span>
        </div>
      </button>
    } @else if (uploading() && editMode()) {
      <button nbButton status="primary" class="upload-button" (click)="abortUpload()">
        <nb-icon icon="close-outline" pack="eva"></nb-icon>
        <div>
          <span class="button-text">Upload abbrechen</span>
          <span class="file-hint">Fortschritt geht verloren</span>
        </div>
      </button>
    }
  </div>
</div>
